import { render, staticRenderFns } from "./FamsCommands.vue?vue&type=template&id=10c8ef32"
import script from "./FamsCommands.vue?vue&type=script&lang=js"
export * from "./FamsCommands.vue?vue&type=script&lang=js"
import style0 from "./FamsCommands.vue?vue&type=style&index=0&id=10c8ef32&prod&lang=scss"
import style1 from "./FamsCommands.vue?vue&type=style&index=1&id=10c8ef32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports